import React, { useState, useRef } from "react";

import useOnClickOutside from "../../Services/helper";
import ManagerInfoDetails from "./ManagerInfoDetails";
import ManagerInfoButton from "./ManagerInfoButton";
import { useFetchManagerInfo } from "./hooks";

import "./style.scss";

const ManagerInfo = () => {
  const [isShowDetails, setShowDetails] = useState(false);
  const [managerInfo, setManagerInfo] = useState(null);
  const node = useRef();

  useOnClickOutside(node, () => setShowDetails(false));

  useFetchManagerInfo(setManagerInfo);

  const showDetailsHandler = () => {
    setShowDetails((prevState) => !prevState);
  };

  return (
    managerInfo && (
      <div ref={node} className="ManagersInfo">
        <ManagerInfoButton
          name={managerInfo.name}
          onShowDetails={showDetailsHandler}
        />
        {isShowDetails && (
          <ManagerInfoDetails
            name={managerInfo.name}
            avatar={managerInfo.avatar}
            email={managerInfo.email}
            skype={managerInfo.skype}
          />
        )}
      </div>
    )
  );
};

export default ManagerInfo;
